import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";

// 유연한 Permissions 타입

const useAuthStore = create(
  devtools(
    persist(
      (set: any, get: any) => ({
        isLogin: false,
        shouldSaveLogin: false,
        loginInfo: "",
        setIsLogin: async (login: boolean) => {
          set({ isLogin: login });
        },
        setShouldSaveLogin: (value: boolean) => {
          set({ shouldSaveLogin: value });
        },
        setLoginInfo: (info: string) => {
          set({ loginInfo: info });
        },
      }),
      { name: "AuthStore" }
    )
  )
);

export default useAuthStore;
